import api, { unwrap } from './client';

// Le réalisé des ventes par ligne libre × année : la facturation réelle (`billing`, par
// défaut) ou le chiffre d'affaires réalisé (`ca`), de la section Réalisé.
export const listBillingActuals = (tenantId, year, kind = 'billing') =>
  unwrap(api.get(`/sales-billing-actuals/${tenantId}/${year}?kind=${kind}`));

export const createBillingActual = (tenantId, year, payload) =>
  unwrap(api.post(`/sales-billing-actuals/${tenantId}/${year}`, payload));

export const updateBillingActual = (tenantId, year, rowId, payload) =>
  unwrap(api.patch(`/sales-billing-actuals/${tenantId}/${year}/${rowId}`, payload));

/* L'ajustement du CA réalisé à la comptabilité : l'offre qui le porte, la comptabilité mois par mois (mois clos). */
export const getCaAdjustment = (tenantId, year) =>
  unwrap(api.get(`/sales-billing-actuals/${tenantId}/${year}/adjustment`));
export const setCaAdjustmentOffer = (tenantId, offerId) =>
  unwrap(api.put(`/sales-billing-actuals/${tenantId}/adjustment`, { offer_id: offerId || null }));

export const deleteBillingActual = (tenantId, year, rowId) =>
  unwrap(api.delete(`/sales-billing-actuals/${tenantId}/${year}/${rowId}`));
